<p-toast class="custom-toast">
</p-toast>